import { ResourceIdentifier } from "../ResourceManager/ResourceIdentifier";
import { Size } from "../MyHelpers";
import { MyCanvas } from "./MyCanvas";
import { ZIndex } from "../ZIndex";
import { Scale } from "../MyHelpers";
import * as PIXI from "pixi.js";
import { Settings } from "../Settings";

export class BigWinCountAnimationPIXIAPP
{
	protected resid: ResourceIdentifier;
	//protected canvas: MyCanvas;

	protected textSize: number;
	//protected strokeSize: number;

	//protected charWidth: number[] = [];
	//protected maxWidth: number = 0;

	//protected gradient: CanvasGradient;
	//protected gradient2: CanvasGradient;

	//protected fontFamily: string;
	//protected textSpaceFactor: number = 1.15;

	//protected color1Gradient: string;
	//protected color2Gradient: string;

	//protected colorInner: string;
	//protected colorOuter: string;


	protected viewPIXIAPP : PIXI.Container = null;
	protected textView : PIXI.Text = null;

	constructor(resid: ResourceIdentifier, size: Size, textSize: number, fontFamily: string) {
		this.resid = resid.Add("BigWinCount");				
		this.textSize = textSize;		
	}
	
	public Display(n: number): void {
		//let numbersAsText = ;		
		this.textView.text= "" + n;		
	}	

	public Update(n : number){
		//if(this.canvas.WasContextLost()){
			this.Display(n);
		//}
	}

	public CreatePIXIAPP(){
		this.viewPIXIAPP = new PIXI.Container();
		this.viewPIXIAPP.name = "BigWinCountanimationPIXIAPP";
		this.viewPIXIAPP.position.set(0,Settings.ScreenHeight * (Settings.Screens - 1));
		this.viewPIXIAPP.visible = false;
		//this.viewPIXIAPP.width = Settings.ScreenWidth;	
		//this.viewPIXIAPP.height = Settings.ScreenHeight;

		this.textView = new PIXI.Text("000",{
            fontFamily: 'NotoSansDisplay-Bold',			
			fontSize: this.textSize,			
			fontWeight: 'bold',
			fill: ["#F2E416", "#F2BE22", "#C2760E", "#F2BE22", "#F2E416"], // gradient
			stroke: 'black',
			strokeThickness:  Scale.fh(8),			
			//wordWrap: true,			
			lineJoin: 'round',
			//textBaseline : "middle",			
        });
		
		this.textView.anchor.set(0.5,0.5);
		this.textView.position.set(Settings.ScreenWidth/2 ,  Settings.ScreenHeight/2 + 	(this.textView.height/2) );		
		this.viewPIXIAPP.addChild(this.textView);		
	}

	public ViewPIXIAPP() : PIXI.Container{
		return this.viewPIXIAPP;
	}
}